import styled from 'styled-components';
import React, { PropsWithChildren } from 'react';
import Spacer from 'features/shared/Spacer';
import { ReactComponent as SortIcon } from './SortOrder.svg';

const SortHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding-left: 12px;
`;

const Sort = styled(SortIcon)<{ direction: string }>`
  ${(props) => props.direction === 'descending' && 'transform: rotate(-180deg) scaleX(-1)'};
  path {
    fill-opacity: ${(props) => (props.direction ? 0.6 : 0.35)};
  }
`;

const SortHeader = ({
  children,
  onClick,
  direction,
}: PropsWithChildren<{ onClick: () => void; direction: string }>) => (
  <SortHeaderContainer onClick={onClick}>
    {children}
    <Spacer size={5} />
    <Sort direction={direction} />
  </SortHeaderContainer>
);

export default SortHeader;
